import { render } from "./Carrousel.vue?vue&type=template&id=027a03b0&scoped=true"
import script from "./Carrousel.vue?vue&type=script&lang=js"
export * from "./Carrousel.vue?vue&type=script&lang=js"

import "./Carrousel.vue?vue&type=style&index=0&id=027a03b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027a03b0"]])

export default __exports__